import axios from 'axios' ; 

const KEY = "AIzaSyAP6R2BD-ezAlg8InZLuDFj4bKYzRQrMOo";

export default axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3' , 
    params: {
        part : 'snippet',
        maxResults : 5 ,
        key : KEY ,
        type : 'video'
    }
    
});